var $4ce06844b60c40b5$exports = {};
$4ce06844b60c40b5$exports = {
  "help": "Pomo\u010D",
  "info": "Informacije"
};
export { $4ce06844b60c40b5$exports as default };